import { styled } from "../../styles";

export const TooltipContainer = styled("div", {
  position: "fixed",
  backgroundColor: "$white",
  border: "1px solid $gray-40",
  borderRadius: "8px",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
  padding: "12px",
  zIndex: 10000,
  maxWidth: "200px",
  pointerEvents: "auto",
});

export const TooltipLabel = styled("div", {
  fontSize: "$text-sm",
  fontWeight: 600,
  color: "$black",
  marginBottom: "8px",
});

export const TooltipImage = styled("img", {
  width: "100%",
  height: "auto",
  maxHeight: "150px",
  objectFit: "contain",
  borderRadius: "4px",
  display: "block",
});

export const TooltipLoading = styled("div", {
  fontSize: "$text-sm",
  color: "$gray-100",
  padding: "20px",
  textAlign: "center",
});

export const TooltipError = styled("div", {
  fontSize: "$text-sm",
  color: "$error",
  padding: "20px",
  textAlign: "center",
});
